import React from "react";

// Option « Reçoit les alertes de planning » en carte à cocher (maquette 10) :
// ce n'est pas un rôle, c'est une option de n'importe quel compte (CE-1365).
const CaseAlertesPlanning = ({ coche, onChange, lectureSeule = false }) => (
  <label className={`choix-role choix-role--case${coche ? " is-checked" : ""}${lectureSeule ? " is-disabled" : ""}`}>
    <input
      type="checkbox"
      name="recoitAlertesPlanning"
      checked={!!coche}
      disabled={lectureSeule}
      onChange={(e) => onChange(e.target.checked)}
    />
    <span>
      <span className="choix-role__titre">Reçoit les alertes de planning</span>
      <span className="choix-role__description">
        Courriel quand aucun créneau n'est disponible pour positionner un allocataire.
      </span>
    </span>
  </label>
);

export default CaseAlertesPlanning;
